import { rgbaToCss } from '../utils/color.js';
import { getVarName } from '../utils/css.js';
import { sliderHeight, fplTrackBorderColorVar, fplTrackBgVar, fplThumbBgVar } from '../slider/slider.css.js';
import { CHECKERBOARD_CHECK_SIZE_VAR, CHECKERBOARD_BACKGROUND } from '../styles/checkerboard.css.js';

// The lighter translucent border token, referenced as a raw CSS var rather than importing the
// `@figma/fpl-tokens` map — this is runtime code, so the import would bundle the whole map.
const BORDER_COLOR = 'var(--color-bordertranslucent)';
const checkerboardCheckSizeVar = getVarName(CHECKERBOARD_CHECK_SIZE_VAR);
// A fraction of the track height, so md shows 3 rows of checks and sm shows 2.
const CHECKERBOARD_CHECK_SIZE = {
    sm: `calc(${sliderHeight} / 2)`,
    md: `calc(${sliderHeight} / 3)`,
};
/**
 * Build the `Slider` CSS variables for an opacity slider showing `color`: a thumb painted
 * with the color composited over white at the current `opacity`, and a track that fades the
 * color from transparent to opaque over a checkerboard.
 */
function makeOpacitySliderStyle(color, opacity, colorSpace, size) {
    return {
        [fplThumbBgVar]: makeThumbColor(color, opacity, colorSpace),
        [fplTrackBgVar]: makeTrackBackground(color, colorSpace),
        // A colored track reads better behind a lighter border than the slider's default.
        [fplTrackBorderColorVar]: BORDER_COLOR,
        [checkerboardCheckSizeVar]: CHECKERBOARD_CHECK_SIZE[size],
    };
}
function makeThumbColor(color, opacity, colorSpace) {
    const blendWithWhite = (channel) => 1 - opacity + channel * opacity;
    return rgbaToCss(blendWithWhite(color.r), blendWithWhite(color.g), blendWithWhite(color.b), 1, colorSpace);
}
function makeTrackBackground(color, colorSpace) {
    // The gradient is inset by half the track height on each side so the fade lines up with
    // the center of the thumb at the ends of its travel.
    const padding = `calc(${sliderHeight} / 2)`;
    const transparent = rgbaToCss(color.r, color.g, color.b, 0, colorSpace);
    const opaque = rgbaToCss(color.r, color.g, color.b, 1, colorSpace);
    const gradient = `linear-gradient(90deg, ${transparent} 0 ${padding}, ${opaque} calc(100% - ${padding}) 100%)`;
    return `${gradient}, ${CHECKERBOARD_BACKGROUND}`;
}

export { makeOpacitySliderStyle };
//# sourceMappingURL=opacity-slider.utils.js.map
